import { StatusType } from '~/eds/src/types/StatusType';

export const calculateCreditEstimate = (
  docsProcessed: number,
  docsInScope: number,
) => Math.max(docsInScope - docsProcessed, 0);

export const getQuotaStatus = ({
  consumedQuota,
  quotaCount,
}: {
  consumedQuota: number;
  quotaCount: number;
}) => {
  const spentQuota = consumedQuota / quotaCount;
  let status;

  if (spentQuota === 0) {
    return undefined;
  } else if (spentQuota > 0 && spentQuota <= 0.5) {
    status = 'success' as StatusType;
  } else if (spentQuota > 0.5 && spentQuota < 1) {
    status = 'warning' as StatusType;
  } else {
    status = 'danger' as StatusType;
  }
  return status;
};
